import { z } from "zod/v4-mini";

import { Schema, cz } from "@/utils/zodUtils.ts";

export type HasDataToSync = { hasDataToSync: boolean };
export const hasDataToSyncSchema: Schema<HasDataToSync> = cz.camelCaseObject({
  has_data_to_sync: z.boolean(),
});

export type DataSyncResult = {
  source: string;
  synced: boolean;
  message: string;
};

export const dataSyncResultSchema: Schema<DataSyncResult> = cz.camelCaseObject({
  source: z.string(),
  synced: z.boolean(),
  message: z.string(),
});

export type DataSync = {
  synced: boolean;
  results: DataSyncResult[];
};

export const dataSyncSchema: Schema<DataSync> = cz.camelCaseObject({
  synced: z.boolean(),
  results: cz.forcedArray(dataSyncResultSchema),
});
